import React from 'react';
import { withRouter } from 'react-router';
import { NavLink, NavLinkProps, RouteComponentProps } from 'react-router-dom';
import { observer } from 'mobx-react';
import styles from './page-header.less';
import { Titles, PageHeaderContainer } from './page-header';

export const NavLinkWithPad = (props: NavLinkProps) => (
    <>
        <NavLink {...props} />
        <div />
    </>
);

interface NavListProps extends RouteComponentProps<void> {
    container: PageHeaderContainer;
    excludePath?: Titles;
}

const NavLinkListBase: React.FC<NavListProps> = observer(({ container, excludePath }) => (
    <React.Fragment>
        {(container.balance > 0 || container.jobs > 0) && excludePath !== Titles.Home && (
            <NavLinkWithPad to="/home" activeClassName={styles.active}>
                Home
            </NavLinkWithPad>
        )}
        {container.balance > 0 && excludePath !== Titles.Invoices && (
            <NavLinkWithPad to="/statements" activeClassName={styles.active}>
                Invoices
            </NavLinkWithPad>
        )}
        {container.jobs > 0 && excludePath !== Titles.History && (
            <NavLinkWithPad to="/history" activeClassName={styles.active}>
                History
            </NavLinkWithPad>
        )}
        {container.isSavePaymentMethodsEnabled && excludePath !== Titles.SavedPayment && (
            <NavLinkWithPad to="/savedpaymentmethod/paymentmethod" activeClassName={styles.active}>
                Saved Payment Methods
            </NavLinkWithPad>
        )}
        {container.showMemberships &&
            excludePath !== Titles.Memberships &&
            excludePath !== Titles.Contracts && (
                <NavLinkWithPad to={container.membershipsRoute} activeClassName={styles.active}>
                    {container.membershipsTabName}
                </NavLinkWithPad>
            )}
    </React.Fragment>
));
export const NavLinkList = withRouter(NavLinkListBase);
